import {
  SyncDateWindow,
  type SyncDateWindowConstructor,
} from '../SyncDateWindow'

export interface QuickBooksSyncSettingsConstructor {
  purchaseOrder: SyncDateWindowConstructor
  bill: SyncDateWindowConstructor
}

export class QuickBooksSyncSettings {
  readonly purchaseOrder: SyncDateWindow
  readonly bill: SyncDateWindow

  constructor(data: QuickBooksSyncSettingsConstructor) {
    this.purchaseOrder = new SyncDateWindow(data.purchaseOrder)
    this.bill = new SyncDateWindow(data.bill)
  }
}
